// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PrintRequestInvoice } from './print-request-invoice';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PrintRequest extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  fileName?: string;
  name?: string;
  printRequestCode!: string;
  printRequestInvoices!: PrintRequestInvoice[];
}

